import { useTranslation } from 'react-i18next';

import ConfirmationModal from '@/components/popups/ConfirmationModal';

interface InvalidNameProps {
  setShowInvalidNameError: (show: boolean) => void;
}

const InvalidName: React.FC<InvalidNameProps> = ({
  setShowInvalidNameError,
}) => {
  const { t } = useTranslation();
  return (
    <ConfirmationModal
      isStep
      bodyText={t('InvalidPlanName.paragraphText')}
      headerText={t('InvalidPlanName.errorHeader')}
      isError={true}
      primaryButtonHandler={() => setShowInvalidNameError(false)}
      primaryButtonText={t('Button.close')}
    />
  );
};

export default InvalidName;
